import { AxiosResponse } from 'axios';
import axios from '../../util/axios';
import { ILinkResponse } from './types';

export default class DynamicLinkService {
    public static getLink(linkToken: string): Promise<ILinkResponse> {
        return axios
            .post('/link/get', { token: linkToken })
            .then((value: AxiosResponse<ILinkResponse>) => value.data);
    }

    public static sendLinkToMobile({
        mobile,
        link,
    }: {
        mobile: string;
        link?: string;
    }): Promise<void> {
        return axios
            .post('/messaging/send_initial_texts/', {
                type: 'download-app',
                mobile,
                link,
            })
            .then(() => {
                console.log('Sent link to mobile');
            })
            .catch((e) => {
                console.error('Error sending link to mobile', e);
                throw e;
            });
    }
}
